<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib">{{ title }}</h2>
      <div class="btn-wrap btn-type1 clearfix">
        <button class="btn-size btn-blue fl_left" @click="goSearch">
          <span class="btn-icon"><i class="fas fa-pen-alt"></i></span> 검색
        </button>
      </div>
    </div>

    <!-- 검색조건 영역 -->
    <div class="desc-content search-border">
      <div class="item desc-left">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문회사</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.visitCompCd">
              <option value="">==전체==</option>
              <option value="100010">일진전기</option>
              <option value="100002">일진홀딩스</option>
              <option value="101301">일진다이아</option>
              <option value="222300">알피니언메디칼</option>
            </b-select>
          </div>
        </div>
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문목적</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.purpose">
              <option value="">==전체==</option>
              <option
                v-for="item in purposes"
                :key="item.key"
                :value="item.key"
                v-text="item.value"
              />
            </b-select>
          </div>
        </div>
      </div>
      <div class="item desc-center">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문일</span>
          </div>
          <div class="desc">
            <div class="datepicker w-type-ymd02">
              <input
                type="text"
                class="input date sDate"
                id="apprDateFrom"
                autocomplete="off"
                v-model="form.startTime"
                @keyup="dateFormat($event)"
                maxlength="8"
              />
            </div>
            <span class="wave"> ~ </span>
            <div class="datepicker w-type-ymd02">
              <input
                type="text"
                class="input date sDate"
                id="apprDateTo"
                autocomplete="off"
                v-model="form.endTime"
                @keyup="dateFormat($event)"
                maxlength="8"
              />
            </div>
          </div>
        </div>

        <search-dept-mg
          title="방문부서"
          v-model="form"
          :options="{
            type: '01',
            deptCd: 'visitDept',
            deptNm: 'deptNm',
            authorize: true,
          }"
          @submit="goSearch"
          style="width: 100%"
        />
      </div>
      <div class="item desc-right">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">회사명</span>
          </div>
          <div class="desc" style="width: 70%">
            <input
              class="input Rt-M tal"
              style="width: 300px"
              type="text"
              v-model="form.visitorComp"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 그래프01 -->
    <div class="desc-content search-border" style="height: auto">
      <div class="graph" style="float: left; width: 33%">
        <div style="padding-bottom: 40px">
          <PieChart
            :chart-data="chartDataOptionL1"
            :options="chartOptionL1"
            :styles="{ height: '250px', position: 'relative' }"
          ></PieChart>
        </div>
        <div>
          <PieChart
            :chart-data="chartDataOptionL2"
            :options="chartOptionL2"
            :styles="{ height: '250px', position: 'relative' }"
          ></PieChart>
        </div>
      </div>
      <div class="graph" style="float: left; width: 33%">
        <div style="padding-bottom: 40px">
          <PieChart
            :chart-data="chartDataOptionM1"
            :options="chartOptionM1"
            :styles="{ height: '250px', position: 'relative' }"
          ></PieChart>
        </div>
        <div>
          <PieChart
            :chart-data="chartDataOptionM2"
            :options="chartOptionM2"
            :styles="{ height: '250px', position: 'relative' }"
          ></PieChart>
        </div>
      </div>
      <div class="graph" style="float: left; width: 33%">
        <div style="padding-bottom: 40px">
          <PieChart
            :chart-data="chartDataOptionR1"
            :options="chartOptionR1"
            :styles="{ height: '250px', position: 'relative' }"
          ></PieChart>
        </div>
      </div>
    </div>
    <!-- 그래프01 -->
  </div>
</template>

<script>
import mixin from "@/mixin";
import mixinSlip from "@/mixin/slip";
import _ from "lodash";
import DhxGrid from "@/components/DhxGrid.vue";
import DhxCalendar from "@/components/DhxCalendar.vue";

import SearchDeptMg from "@/components/SearchDeptMg.vue";
import BarChart from "@/components/chart/BarChart";
import PieChart from "@/components/chart/PieChart";
import "chartjs-plugin-annotation";
import "chartjs-plugin-labels";

export default {
  name: "VisitStatisticsCategoryMg",
  components: { DhxGrid, DhxCalendar, BarChart, PieChart, SearchDeptMg },
  mixins: [mixin, mixinSlip],
  data() {
    return {
      title: "구분별통계",
      datacollection1: null,
      datacollection2: null,
      businessAreaCds: [],
      purposes: [],
      chartData1: [],
      chartData2: [],
      chartData3: [],
      chartData4: [],
      chartData5: [],
      chartDataOptionL1: {},
      chartDataOptionL2: {},
      chartDataOptionM1: {},
      chartDataOptionM2: {},
      chartDataOptionR1: {},
      chartOptionL1: {
        plugins: {
          labels: {
            //render: 'percentage',
            render: (args) => {
              return args.value + "\r\n" + "(" + args.percentage.toFixed(1) + "%)";
            },
            precision: 5,
            fontColor: "black",
            fontStyle: "bold",
            //position:''
          },
        },
        title: {
          display: true,
          text: "방문목적별 방문건수(방문완료)",
          fontSize: 16,
          fontColor: "black",
          fontStyle: "bold",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            fontColor: "black",
            fontStyle: "bold",
          },
        },
        tooltips: {
          enabled: true,
        },
        animation: {
          // duration: 10
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          center: {
            fontStyle: "Helvetica", //Default Arial
            sidePadding: 15, //Default 20 (as a percentage)
          },
        },
      },
      chartOptionL2: {
        plugins: {
          labels: {
            //render: 'percentage',
            render: (args) => {
              return args.value + "\r\n" + "(" + args.percentage.toFixed(1) + "%)";
            },
            precision: 5,
            fontColor: "black",
            fontStyle: "bold",
            //position:''
          },
        },
        title: {
          display: true,
          text: "방문목적별 실방문객수",
          fontSize: 16,
          fontColor: "black",
          fontStyle: "bold",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            fontColor: "black",
            fontStyle: "bold",
          },
        },
        tooltips: {
          enabled: true,
        },
        animation: {
          // duration: 10
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          center: {
            fontStyle: "Helvetica", //Default Arial
            sidePadding: 15, //Default 20 (as a percentage)
          },
        },
      },
      chartOptionM1: {
        plugins: {
          labels: {
            //render: 'percentage',
            render: (args) => {
              return args.value + "\r\n" + "(" + args.percentage.toFixed(1) + "%)";
            },
            precision: 5,
            fontColor: "black",
            fontStyle: "bold",
            //position:''
          },
        },
        title: {
          display: true,
          text: "방문회사별 방문건수(방문완료)",
          fontSize: 16,
          fontColor: "black",
          fontStyle: "bold",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            fontColor: "black",
            fontStyle: "bold",
          },
        },
        tooltips: {
          enabled: true,
        },
        animation: {
          // duration: 10
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          center: {
            fontStyle: "Helvetica", //Default Arial
            sidePadding: 15, //Default 20 (as a percentage)
          },
        },
      },
      chartOptionM2: {
        plugins: {
          labels: {
            //render: 'percentage',
            render: (args) => {
              return args.value + "\r\n" + "(" + args.percentage.toFixed(1) + "%)";
            },
            precision: 5,
            fontColor: "black",
            fontStyle: "bold",
            //position:''
          },
        },
        title: {
          display: true,
          text: "방문회사별 실방문객수",
          fontSize: 16,
          fontColor: "black",
          fontStyle: "bold",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            fontColor: "black",
            fontStyle: "bold",
          },
        },
        tooltips: {
          enabled: true,
        },
        animation: {
          // duration: 10
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          center: {
            fontStyle: "Helvetica", //Default Arial
            sidePadding: 15, //Default 20 (as a percentage)
          },
        },
      },
      chartOptionR1: {
        plugins: {
          labels: {
            //render: 'percentage',
            render: (args) => {
              return args.value + "\r\n" + "(" + args.percentage.toFixed(1) + "%)";
            },
            precision: 5,
            fontColor: "black",
            fontStyle: "bold",
            //position:''
          },
        },
        title: {
          display: true,
          text: "방문상태별 방문신청건수",
          fontSize: 16,
          fontColor: "black",
          fontStyle: "bold",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            fontColor: "black",
            fontStyle: "bold",
          },
        },
        tooltips: {
          enabled: true,
        },
        animation: {
          // duration: 10
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          center: {
            fontStyle: "Helvetica", //Default Arial
            sidePadding: 15, //Default 20 (as a percentage)
          },
        },
      },
      form: {
        startTime: this.$moment().add(-1, "month").format("YYYY-MM-DD"),
        endTime: this.$moment().format("YYYY-MM-DD"),
        businessAreaCd: "",
        purpose: "",
        visitorComp: "",
        visitDept: "",
        visitCompCd: "",
      },
    };
  },
  methods: {
    dateFormat(e) {
      var value = e.target.value;
      e.target.value = value.replace(/[^0-9]/g, "");

      if (e.target.value.length == 8) {
        e.target.value =
          e.target.value.substring(0, 4) +
          "-" +
          e.target.value.substring(4, 6) +
          "-" +
          e.target.value.substring(6, 8);
      }
    },
    calendarLoad() {
      const iljinCalendar1 = new dhtmlXCalendarObject("apprDateFrom");
      iljinCalendar1.setDate(new Date());
      iljinCalendar1.setDateFormat("%Y-%m-%d");
      iljinCalendar1.attachEvent(
        "onChange",
        () => (this.form.startTime = this.$refs.apprDateFrom.getFormatedDate())
      );
      iljinCalendar1.attachEvent("onButtonClick", (d) => {
        if (d === null) {
          this.form.startTime = this.$refs.apprDateFrom.getFormatedDate();
        }
      });
      this.$refs.apprDateFrom = iljinCalendar1;

      const iljinCalendar2 = new dhtmlXCalendarObject("apprDateTo");
      iljinCalendar2.setDate(new Date());
      iljinCalendar2.setDateFormat("%Y-%m-%d");
      iljinCalendar2.attachEvent(
        "onChange",
        () => (this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m-%d"))
      );
      iljinCalendar2.attachEvent("onButtonClick", (d) => {
        if (d === null) {
          this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m-%d");
        }
      });
      this.$refs.apprDateTo = iljinCalendar2;
    },
    //사업장
    getBusinessAreaCdCombo() {
      this.$http
        .get("/api/auth/user/business", {
          params: {
            empNo: this.$store.state.loginInfo.loginId,
          },
        })
        .then((response) => {
          this.businessAreaCds = response.data;
        });
    },
    //방문목적
    getPurposeCdCombo() {
      this.$http
        .get(`/api/code/combo`, { params: { groupCd: "PURPOSE_CD" } })
        .then((response) => {
          this.purposes = response.data;
        });
    },
    saveExcel() {
      if (_.isEmpty(this.gridDataList)) {
        this.$swal({ type: "warning", text: "엑셀데이터없음" });
        return false;
      }

      this.downloadExcel(this.$refs.grid);
    },
    goSearch() {
      const stDt = this.$moment(this.form.startTime);
      const enDt = this.$moment(this.form.endTime);
      const diff = this.$moment.duration(enDt.diff(stDt)).asDays();

      if (diff > 365) {
        this.$swal({ type: "warning", text: "선택가능기간은 최대 365일입니다" });
        return;
      }

      const param = JSON.parse(JSON.stringify(this.form));
      if (!this.validation(param)) return;

      this.$store.commit("loading");
      try {
        this.$http
          .post(`/api/statistics/categoryMg`, param)
          .then((response) => {
            this.chartData1 = response.data.firstChart;
            this.chartData2 = response.data.secondChart;
            this.chartData3 = response.data.thirdChart;
            this.chartData4 = response.data.fourthChart;
            this.chartData5 = response.data.fifthChart;
            this.$store.commit("finish");
            setTimeout(() => {
              this.fillData();
            }, 100);
          })
          .catch((e) => {
            console.error(e.toString());
            this.$swal({ type: "error", text: "검색 오류" });
            this.chartData1 = [];
            this.chartData2 = [];
            this.chartData3 = [];
            this.chartData4 = [];
            this.chartData5 = [];
            this.$store.commit("finish");
          });
      } catch (e) {
        this.$store.commit("finish");
      }
    },
    validation(param) {
      if (!param.startTime || !param.endTime) {
        this.$swal({ type: "warning", text: "작업일자를 선택해 주세요." });
        return false;
      }
      return true;
    },
    fillData() {
      this.chartDataOptionL1 = {
        labels: this.chartData1.label,
        datasets: [
          {
            backgroundColor: [
              "#7dff84",
              "#b5cfff",
              "#fffbb5",
              "#ffb5e6",
              "#b5f4ff",
              "#b5ffc8",
            ],
            data: this.chartData1.totalDoneCnt,
            text: this.chartData1.totalDoneCnt,
          },
        ],
      };
      this.chartDataOptionL2 = {
        labels: this.chartData2.label,
        datasets: [
          {
            backgroundColor: [
              "#7dff84",
              "#b5cfff",
              "#fffbb5",
              "#ffb5e6",
              "#b5f4ff",
              "#b5ffc8",
            ],
            data: this.chartData2.visitorsCnt,
            text: this.chartData2.visitorsCnt,
          },
        ],
      };
      this.chartDataOptionM1 = {
        labels: this.chartData3.label,
        datasets: [
          {
            backgroundColor: [
              "#7dff84",
              "#b5cfff",
              "#fffbb5",
              "#ffb5e6",
              "#b5f4ff",
              "#b5ffc8",
            ],
            data: this.chartData3.totalDoneCnt,
            text: this.chartData3.totalDoneCnt,
          },
        ],
      };
      this.chartDataOptionM2 = {
        labels: this.chartData4.label,
        datasets: [
          {
            backgroundColor: [
              "#7dff84",
              "#b5cfff",
              "#fffbb5",
              "#ffb5e6",
              "#b5f4ff",
              "#b5ffc8",
            ],
            data: this.chartData4.visitorsCnt,
            text: this.chartData4.visitorsCnt,
          },
        ],
      };
      this.chartDataOptionR1 = {
        labels: this.chartData5.label,
        datasets: [
          {
            backgroundColor: [
              "#7dff84",
              "#b5cfff",
              "#fffbb5",
              "#ffb5e6",
              "#b5f4ff",
              "#b5ffc8",
            ],
            data: this.chartData5.totalCnt,
            text: this.chartData5.totalCnt,
          },
        ],
      };
    },
  },

  created() {
    //Admin 권한 체크
    if(this.$store.state.loginInfo.authorities[0].roleCd != "ADMIN") {
      setTimeout(()=> {
        this.$swal({type: 'warning', text: '관리자만 접속 가능합니다.'})
            ,100});
      this.$router.push({path: `/ijmt`});
    };
  },

  mounted() {
    /*콤보조회*/
    this.getBusinessAreaCdCombo();
    this.getPurposeCdCombo();
    /*차트 셋팅*/
    /*그리드조회*/
    this.calendarLoad();
    this.goSearch();
  },
};
</script>

<style scoped>
.desc-content:after {
  clear: both;
  content: "";
  display: block;
}

.btn-wrap {
  margin-bottom: 20px;
}

.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}

.desc-content .item {
  float: left;
}

.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}

.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}

.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}

.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}

.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}

.desc-content .item.desc-center .desc-item {
  padding-left: 90px;
}

.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}

.desc-content .item.desc-center .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}

.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}

.desc-content .item.desc-center .desc-item .desc .datepicker {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}

.desc-content .item.desc-center .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}

.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: "";
  display: block;
}

.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}

.desc-content .item.desc-center .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-center .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}

.desc-content .item.desc-left {
  width: 30%;
  padding-right: 40px;
}

.desc-content .item.desc-center {
  width: 45%;
  padding-right: 40px;
}

.desc-content .item.desc-right {
  width: 25%;
}

.search-area input {
  position: relative;
}

.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}

.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}

.search-border .td-s-thumb.search-area > input,
.search-border
  .td-s-thumb.search-area
  > .ip-box
  .search-border
  .td-s-thumb.search-area
  > button {
  float: left;
}

.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}

.remove_text {
  margin-left: 0;
}

.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
  max-height: 0px;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}

.big {
  width: auto;
}

.small {
  max-width: 200px;
}

/*
  .desc{
      margin-left:40px;
  }*/
</style>
